const data = [
  {
    name: "GlobalSearch",
    backgroundColor: "#fff"
  }
];

export default data;
